import React, { useContext, useState } from 'react';
import * as XLSX from 'xlsx';
import {dados} from './stdBoletim'
import { stdValue } from '../../../../Resources/setNumber';
import BoletinsHooks from '../../../../Hooks/boletinsHooks';
import GlobalStateContext from '../../../../components/GlobalStateContext';
import {IconButton, Box, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import SearchIcon from '@mui/icons-material/Search';
import LoadingDialog from '../../../../components/ui/LoadingDialog';



const ImpRealDia =  ({setRealDia, realDia}) => {
  const {user, site, data, setData} = useContext(GlobalStateContext)
  const [bltData, setBltData] = useState(null);
  const [error, setError] = useState(null);
  const [fileName, setFileName] = useState('');
  const [date, setDate] = useState('');
  const [gridData, setGridData] = useState([]);
  const {novoBoletim} = BoletinsHooks()
  const [loadingMessage, setLoadingMessage] = useState('');
  const [openLoading, setOpenLoading] = useState(false);

  const handleFileUpload = (event) => {
    console.log('handleFileUpload')
    const file = event.target.files[0];
    if (!file) {
      setError('Nenhum arquivo foi selecionado');
      return;
    }
    if (file) {
      setFileName(file.name);
    } else {
      setFileName('');  // Limpar o nome se nenhum arquivo for selecionado
    }
  
    const reader = new FileReader();
  
    reader.onload = async (e) => {  // Marcar como async
      try {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
  
        if (workbook.SheetNames.length === 0) {
          setError('O arquivo Excel não contém planilhas');
          return;
        }
  
        const sheetName = workbook.SheetNames[0];
        console.log('sheetName', sheetName)
        const worksheet = workbook.Sheets[sheetName];
        let jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,   // Lê os dados linha por linha
          defval: null, // Define valor padrão para células vazias
          raw: true    // Mantém o formato original dos valores
        });
  
        if (jsonData.length === 0) {
          setError('A planilha selecionada está vazia');
          return;
        }
  
        const removeEmptyCells = (data) => {
          return data.map(row => row.filter(cell => cell !== null && cell !== ''));
        };
  
        jsonData = removeEmptyCells(jsonData)
        jsonData.shift() // Remove o primeiro item do array
        let dados = {}
        let currentGroup = null
        
        jsonData.forEach(item => {
          if (item.length > 2) {
            // Inicia um novo grupo
            currentGroup = item[0]
            if (currentGroup[0] === ' ') {
              currentGroup = currentGroup.substring(1)
            }
            dados[currentGroup] = {}
            // Adiciona o primeiro item do grupo
            let key = item[1]
            if (key && key[0] === ' ') {
              key = key.substring(1)
            }
            dados[currentGroup][key] = item[2]
          } else if (currentGroup && item.length >= 2) {
            // Adiciona item ao grupo atual
            let key = item[0]
            if (key[0] === ' ') {
              key = key.substring(1)
            }
            dados[currentGroup][key] = item[1]
          }
        })
  
        console.log('jsonData', jsonData, dados)
        setRealDia(dados)
        
        // Preparar dados para o DataGrid
        const prepareGridData = () => {
          const rows = [];
          let id = 0;
          
          Object.keys(dados).forEach(groupName => {
            const groupItems = dados[groupName];
            const itemKeys = Object.keys(groupItems);
            
            itemKeys.forEach((itemKey, index) => {
              rows.push({
                id: id++,
                grupo: index === 0 ? groupName : '', // Só mostra o nome do grupo na primeira linha
                chave: itemKey,
                valor: groupItems[itemKey],
                grupoOriginal: groupName // Para referência
              });
            });
          });
          
          return rows;
        };
        
        setGridData(prepareGridData());
        setError(null);
      } catch (error) {
        setError('Erro ao processar o arquivo Excel');
      }
    };
  
    reader.onerror = () => {
      setError('Erro ao ler o arquivo');
    };
  
    reader.readAsBinaryString(file);
  };

  

 const handleClick = () => {
  document.getElementById('fileInput').click();
};

async function setdataToBme(){
  setLoadingMessage('Alterando dados...')
  setOpenLoading(true)
  try {
  let temp = JSON.parse(JSON.stringify(data))
  let dados = desagruparRealDia(realDia)
  Object.keys(table).forEach(key => {
    // console.log('key', key, table[key], dados[key])
    if (key === "PRODUÇÃO ET. ANIDRO DIA"){
      temp[table[key]].valor = dados[key]/1000
    } else {
      temp[table[key]].valor = dados[key]
    }
  })
  let melProduzido = dados['KG MEL PRODUZIDO']/1000/24
  let melConsumido = dados['KG MEL CONSUMIDO']/1000/24
  let flowMelpEstoque = 0
  let flowMelEstoque = 0
  if (melProduzido > melConsumido){
    flowMelpEstoque = melProduzido - melConsumido
  } else {
    flowMelEstoque = melConsumido - melProduzido
  }
  temp['flowMelpEstoque'].valor = flowMelpEstoque
  temp['flowMelEstoque'].valor = flowMelEstoque
  setLoadingMessage('Recalculando BME...')
  const response = await fetch(''+global.endPoint+'/'+site+'/'+user?.uid+'/calcAllLoc', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({data: temp})
  });
  if (!response.ok) {
    console.log('response', response)
    throw new Error('Erro ao buscar dados da API');
  }
  const jsonData = await response.json()
  setOpenLoading(false)
  setData(jsonData)
  } catch (error) {
    setError('Erro ao alterar dados')
  } finally {
    setOpenLoading(false)
  }
}

  return (
    <Box sx={{display: 'flex', flexDirection: 'column'}}>
      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'left'}}>
        <Tooltip title='Importar Dados'>
          <IconButton color='primary' onClick={handleClick}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
       
          <input
          id="fileInput"
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileUpload}
            style={{display: 'none'}}
          />
           <Tooltip title='Enivar dados para BME'>
          <IconButton color='primary' onClick={setdataToBme} disabled={!realDia}>
            <UploadIcon />
            </IconButton>
          </Tooltip>
      </Box>
     
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {realDia && 
        <Box sx={{ height: 'calc(100vh - 135px)', width: '100%', mt: 0, overflow: 'auto' }}>
          <Table stickyHeader sx={{ tableLayout: "fixed", width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell 
                  sx={{ 
                    fontWeight: "bold", 
                    textAlign: 'left', 
                    padding: '0px', 
                    fontSize: '11px', 
                    paddingLeft: '10px', 
                    paddingTop: '4px', 
                    paddingBottom: '0px', 
                    width: '300px', 
                    position: "sticky", 
                    left: 0, 
                    zIndex: 5, 
                    backgroundColor: "#f5f5f5"
                  }}
                >
                  DESCRIÇÃO
                </TableCell>
                <TableCell
                  sx={{ 
                    fontWeight: "bold", 
                    textAlign: 'left', 
                    padding: '0px', 
                    paddingTop: '4px', 
                    paddingBottom: '0px', 
                    fontSize: '11px',
                    backgroundColor: "#f5f5f5"
                  }}
                >
                  VALOR
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(realDia).map((groupName, groupIndex) => (
                <React.Fragment key={`fragment-${groupName}-${groupIndex}`}>
                  <TableRow sx={{position: "sticky", top: 29, left: 0, zIndex: 8}}>
                    <TableCell 
                      colSpan={2} 
                      sx={{ 
                        borderTop: '1px solid #f2f2f2', 
                        fontSize: '10px', 
                        textAlign: "left", 
                        fontWeight: "bold", 
                        padding: "4px 16px", 
                        backgroundColor: "#f5f5f5", 
                        position: "sticky",
                        left: 0, 
                        zIndex: 20
                      }}
                    >
                      {groupName}
                    </TableCell>
                  </TableRow>
                  {Object.keys(realDia[groupName]).map((itemKey, index) => (
                    <TableRow 
                      key={`rowData-${groupName}-${itemKey}-${index}`} 
                      sx={{ 
                        backgroundColor: "white", 
                        "&:hover": { backgroundColor: "#f5f5f5" } 
                      }}
                    >
                      <TableCell 
                        sx={{
                          textAlign: 'left', 
                          padding: '0px', 
                          fontSize: '11px', 
                          paddingLeft: '10px', 
                          paddingTop: '4px', 
                          paddingBottom: '0px', 
                          width: '300px', 
                          position: "sticky", 
                          left: 0, 
                          zIndex: 3,
                          backgroundColor: "inherit",
                          "&:hover": { backgroundColor: "#f5f5f5", zIndex: 3 }
                        }}
                      >
                        {itemKey}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left', 
                          padding: '0px', 
                          paddingTop: '4px', 
                          paddingBottom: '0px', 
                          fontSize: '11px',
                          backgroundColor: "inherit",
                          "&:hover": { backgroundColor: "#f5f5f5" }
                        }}
                      >
                        {stdValue(realDia[groupName][itemKey])}
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </Box>
      }
      <LoadingDialog open={openLoading} statusMessage={loadingMessage}/>
    </Box>
  );
};

export default ImpRealDia;

function desagruparRealDia(obj) {
  const resultado = {};
  
  Object.keys(obj).forEach(grupo => {
    const itens = obj[grupo];
    Object.keys(itens).forEach(item => {
      resultado[item] = itens[item];
    });
  });
  
  return resultado;
}


let table = {
"MOAGEM HORÁRIA": 'flowCana',
"ART % CANA": 'artCana',
"PUREZA % CANA": 'purezaCana',
"FIBRA % CANA": 'fibraCana',
"AR % CANA": 'arCana',
"EMBEBIÇÃO % FIBRA": 'fibraEmbeb',
"EFICIÊNCIA EXTRAÇÃO": 'efExtMoenda',
"FIBRA BAGAÇO": 'fibraBagaco',
"UMIDADE BAGAÇO": 'umidBagaco',
"RELAÇÃO TORTA CANA": 'prodTorta',
"PERDA LAVAGEM CANA": 'perdaArtLavagemCana',
"PERDA ART TORTA": 'perdaArtTorta',
"PERDA MULTIJATO FÁBRICA": 'perdaArtMultijatoFabrica',
"PERDA SAÍDA EVAPORAÇÃO": 'perdaArtSaidaEvap',
"PERDA SAÍDA VÁCUO": 'perdaArtSaidaVacuo',
"PERDAS ÁGUAS RESIDUAIS": 'perdaArtAguaResiduaria',
"PERDAS INDETERMINADAS": 'perdaArtIndeterminda',
"BRIX XAROPE": 'brixXarope',
"BRIX DO MOSTO": 'brixMosto',
"CONC. CÉL. VINHO BRUTO": 'concCelVinhoBruto',
"CONC. CÉL. VINHO CREME": 'concCelCreme',
"CONC. CÉL. VINHO CENT": 'concCelVinhoCent',
"TAXA DE RECICLO": 'taxaReciclo',
"EFICIÊNCIA FERMENTAÇÃO": 'efFermentacao',
// "KG MEL CONSUMIDO": 'kgMelConsumido',
// "KG MEL PRODUZIDO": 'kgMelProduzido',
"PRODUÇÃO ET. ANIDRO DIA": 'flowEtanolAnidroDia',
"PUREZA XAROPE": 'purezaXarope',
"PUREZA MEL POBRE": 'purezaMelAPobre',
"PUEZA MEL POBRE": 'purezaMelAPobre',
"PUREZA MEL FINAL": 'purezaMelFinal',
"PUREZA MAGMA": 'purezaMagma',
"PUREZA MASSA A": 'purezaMassaA',
"PUREZA MASSA B": 'purezaMassaB',
"BRIX MEL POBRE": 'brixMelAPobre',
"BRIX MEL FINAL": 'brixMelFinal',
"BRIX MAGMA": 'brixMagma'}


